const SHOP_WHATSAPP_NUMBER = '919972454799';

function formatMoney(amount) {
  return `₹${Number(amount || 0).toLocaleString('en-IN')}`;
}

export function buildShopInquiryWhatsAppMessage({
  inquiryNo,
  cart,
  customerName,
  phone,
  deliveryDate,
  itemName,
  hidePrices = false,
  t,
}) {
  const lines = [
    t('whatsapp.inquiryIntro', { inquiryNo }),
    '',
    `${t('checkoutModal.fullName')}: ${customerName}`,
    `${t('checkoutModal.phone')}: ${phone}`,
  ];

  if (deliveryDate) {
    lines.push(`${t('checkoutModal.deliveryDate')}: ${deliveryDate}`);
  }

  lines.push('', t('whatsapp.itemsHeader'));

  cart.forEach((item, index) => {
    const name = itemName ? itemName(item) : item.modelName;
    const code = item.modelNumber || item.id;
    if (hidePrices) {
      lines.push(`${index + 1}. ${name} (${code}) x${item.quantity}`);
    } else {
      lines.push(
        `${index + 1}. ${name} (${code}) x${item.quantity} — ${formatMoney((item.price || item.unitPrice || 0) * item.quantity)}`
      );
    }
    if (item.customRequest?.trim()) {
      lines.push(`   ${t('orderModal.customRequest')}: ${item.customRequest.trim()}`);
    }
  });

  if (!hidePrices) {
    const total = cart.reduce(
      (sum, item) => sum + (item.price || item.unitPrice || 0) * item.quantity,
      0
    );
    const advance = cart.reduce((sum, item) => sum + (item.advanceAmount || 0), 0);

    lines.push(
      '',
      `${t('checkoutModal.totalAmount')}: ${formatMoney(total)}`,
      `${t('checkoutModal.advanceLabel')}: ${formatMoney(advance)}`,
    );
  }

  lines.push('', t('whatsapp.footer'));

  return lines.join('\n');
}

export function buildShopInquiryWhatsAppUrl(params) {
  const text = buildShopInquiryWhatsAppMessage(params);
  return `https://wa.me/${SHOP_WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function openShopInquiryWhatsApp(params) {
  const url = buildShopInquiryWhatsAppUrl(params);
  window.open(url, '_blank', 'noopener,noreferrer');
}
